const EXTENSION_TO_MIME: { [key: string]: string[] } = {
  // Documents
  '.pdf': ['application/pdf'],
  '.doc': ['application/msword'],
  '.docx': ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  '.xls': ['application/vnd.ms-excel', 'application/x-excel'],
  '.xlsx': ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  '.ppt': ['application/vnd.ms-powerpoint'],
  '.pptx': ['application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  '.txt': ['text/plain'],
  '.rtf': ['application/rtf', 'text/rtf'],
  '.csv': ['text/csv', 'application/csv'],

  // Images
  '.jpg': ['image/jpeg'],
  '.jpeg': ['image/jpeg'],
  '.png': ['image/png'],
  '.gif': ['image/gif'],
  '.bmp': ['image/bmp', 'image/x-windows-bmp'],
  '.webp': ['image/webp'],
  '.svg': ['image/svg+xml'],
  '.ico': ['image/x-icon', 'image/vnd.microsoft.icon'],
  '.tiff': ['image/tiff'],
  '.tif': ['image/tiff'],

  // Audio
  '.mp3': ['audio/mpeg', 'audio/mp3'],
  '.wav': ['audio/wav', 'audio/x-wav'],
  '.ogg': ['audio/ogg', 'application/ogg'],
  '.m4a': ['audio/mp4', 'audio/x-m4a'],

  // Video
  '.mp4': ['video/mp4'],
  '.avi': ['video/x-msvideo', 'video/avi'],
  '.mov': ['video/quicktime'],
  '.wmv': ['video/x-ms-wmv'],
  '.flv': ['video/x-flv'],
  '.webm': ['video/webm'],
  '.mkv': ['video/x-matroska'],

  // Archives
  '.zip': ['application/zip', 'application/x-zip-compressed'],
  '.rar': ['application/vnd.rar', 'application/x-rar-compressed'],
  '.7z': ['application/x-7z-compressed'],
  '.tar': ['application/x-tar'],
  '.gz': ['application/gzip', 'application/x-gzip'],

  // Web files
  '.html': ['text/html'],
  '.htm': ['text/html'],
  '.css': ['text/css'],
  '.js': ['text/javascript', 'application/javascript'],
  '.json': ['application/json'],
  '.xml': ['application/xml', 'text/xml'],
  '.xsl': ['application/xslt+xml'],

  // Fonts
  '.ttf': ['font/ttf', 'application/x-font-ttf'],
  '.otf': ['font/otf', 'application/x-font-opentype'],
  '.woff': ['font/woff', 'application/font-woff'],
  '.woff2': ['font/woff2'],
  '.eot': ['application/vnd.ms-fontobject'],
};

export const extensionToMime = (extension: string): string[] | null => {
  return EXTENSION_TO_MIME[extension.toLowerCase()] || null;
};

export const mimeToExtension = (mimeType: string): string | null => {
  const extension = Object.keys(EXTENSION_TO_MIME).filter((ext) =>
    EXTENSION_TO_MIME[ext].includes(mimeType.toLowerCase()),
  );
  return extension[0] || null;
};
